export const SERVER_URL = "https://crmapi.appnestit.com"
export const FRONTEND_URL = "https://crm.appnestit.com"
// export const SERVER_URL = "http://127.0.0.1:7000"
// export const FRONTEND_URL = "http://127.0.0.1:3000"